export const Survey = () => {
    return (
        <iframe
            src="/survey/sc-survey.html"
            title="Survey"
            style={{
                width: "100%",
                height: "100vh",
                border: "none"
            }}
        />
    );
};